import { render, staticRenderFns } from "./success-buy-full.vue?vue&type=template&id=e2291f5e&scoped=true"
import script from "./success-buy-full.vue?vue&type=script&lang=js"
export * from "./success-buy-full.vue?vue&type=script&lang=js"
import style0 from "./success-buy-full.vue?vue&type=style&index=0&id=e2291f5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2291f5e",
  null
  
)

export default component.exports